export const typeBgKey = '__bg-type';